import { lazy, type FC, type LazyExoticComponent } from "react";

const SignIn = lazy(() => import("@pages/AuthPages/SignIn"));
const ForgotPassword = lazy(() => import("@pages/AuthPages/ForgotPassword"));
const Verification = lazy(() => import("@pages/AuthPages/verification"));
const ResetPassword = lazy(() => import("@pages/AuthPages/ResetPassword"));

interface RouteConfig {
  path: string;
  title: string;
  component: LazyExoticComponent<FC>;
}

const authRoute: RouteConfig[] = [
  { path: "/signin", component: SignIn, title: "Signin" },
  { path: "/forgot-password", component: ForgotPassword, title: "Signin" },
  { path: "/verification", component: Verification, title: "Verification" },
  { path: "/reset-password", component: ResetPassword, title: "ResetPassword" },
];

export default authRoute;
